import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const MAY_2025_CAMPAIGN_END_DATE = d(2025, 6, 2, 0, 0);
